export const columns = [
  {
    Header: '#',
    accessor: 'id',
  },
  {
    Header: 'Avatar',
    accessor: 'avatar',
    disableSortBy: true,
    disableGlobalFilter: true,
    Cell: () => {
      return (
        <img src={`${process.env.PUBLIC_URL}/img/user-avatar.svg`} alt="Avatar" style={{width: "100%", maxWidth: "68px"}} />
      )
    },
  },
  {
    Header: 'Name',
    accessor: 'first_name',
  },
  {
    Header: 'Role',
    accessor: 'role',
  },
  {
    Header: 'Email/Slack',
    accessor: 'email',
  },

  {
    Header: 'Phone',
    accessor: 'phone',
  },
  {
    Header: 'Joined',
    accessor: 'date_signup',
  },
  {
    Header: 'Status',
    accessor: 'is_active',
  },
  {
    Header: 'Salary',
    accessor: 'salary',
  },
  {
    Header: 'Mnur',
    accessor: 'min_non_upwork_sale_rate',
  },
  {
    Header: 'Mur',
    accessor: 'min_upwork_sale_rate',
  },
  {
    Header: 'Osr',
    accessor: 'optimal_sale_rate',
  },
  {
    Header: 'Vacation Days',
    accessor: 'vacation_days',
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    disableGlobalFilter: true,
    disableSortBy: true
  },
];



